export const TOPUP_DEEPLINK_QUERY_PARAMS = {
  CURRENCY: 'currency',
  APP_ID: 'app_id',
};

export const TOPUP_DEEPLINK_SESSION_KEYS = {
  RETURN_URL: 'topup_deeplink.returnUrl',
};

export const TOPUP_ACCOUNTS_QUERY_PARAM = 'topup';

export const TOPUP_SELECT_CURRENCY = 'select';
